import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { RxReactiveFormCompositeComponent, RxTextCompositeComponent } from '@nrwl/rx-forms';
import { FormsValidatorsService } from '@nrwl/rx-forms-dialog-config';
import { IPRestriction } from '@nrwl/rx-models';
import { RxTextareaComponent } from '@nrwl/rx-textarea';
import {
  rxCheckedValidator,
  rxNumericCheckValidator,
  rxRequiredValidator,
} from '@nrwl/rx-validators';
import { DialogsConfigService } from '../dialogs-config.service';
import { RxCheckboxComponent } from '@nrwl/rx-checkbox';
import { RxRowComponent } from 'libs/rx-ui/src/lib/rx-row/rx-row.component';

@Injectable({
  providedIn: 'root',
})
export class RestrictionsDialogConfigService extends DialogsConfigService {
  constructor(public formsValidatorsService: FormsValidatorsService) {
    super();
  }

  public enableSharedForms2fa() {
    return {
      component: RxReactiveFormCompositeComponent,
      width: '600px',
      payload: {
        title: 'Note',
        tip: `Please check the boxes <span class="checkbox"></span> indicating that you have been notified of the advice.`,
        tipTemplate: null,
        tipClose: false,
        buttons: this.SubmitDismissButtons('Enable 2FA', 'Cancel'),
        resultRequired: true,
        fields: [
          {
            component: RxCheckboxComponent,
            title: `You won't be able to share Forms with Clients who have no phone and email <span class="red">*</span>`,
            value: null,
            validators: [rxCheckedValidator],
          },
          {
            component: RxCheckboxComponent,
            title: `Client should have access to phone/email to get access to shared Forms <span class="red">*</span>`,
            value: null,
            validators: [rxCheckedValidator],
          },
          {
            component: RxRowComponent,
          },
        ],
      },
    };
  }

  public enableSharedForms2faEMR() {
    return {
      component: RxReactiveFormCompositeComponent,
      width: '600px',
      payload: {
        title: 'Note',
        tip: `Please check the boxes <span class="checkbox"></span> indicating that you have been notified of the advice.`,
        tipTemplate: null,
        tipClose: false,
        buttons: this.SubmitDismissButtons('Enable 2FA', 'Cancel'),
        resultRequired: true,
        fields: [
          {
            component: RxCheckboxComponent,
            title: `You won't be able to share Forms with Clients who have no phone and email <span class="red">*</span>`,
            value: null,
            validators: [rxCheckedValidator],
          },
          {
            component: RxCheckboxComponent,
            title: `Client should have access to phone/email to get access to shared Forms <span class="red">*</span>`,
            value: null,
            validators: [rxCheckedValidator],
          },
          {
            component: RxRowComponent,
          },
          {
            component: RxCheckboxComponent,
            title: `Please ensure Client's DOB data presents in RxPhoto Client Record <span class="red">*</span>`,
            value: null,
            validators: [rxCheckedValidator],
          },
          {
            component: RxCheckboxComponent,
            title: `Please ensure Client's DOB is correct <span class="red">*</span>`,
            value: null,
            validators: [rxCheckedValidator],
          },
        ],
      },
    };
  }

  public editIPRestriction(restriction?: IPRestriction) {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: restriction ? 'Edit IP Restriction' : 'Add IP Restriction',
        tipClose: false,
        buttons: this.SubmitDismissButtons('Save', 'Cancel'),
        fields: [
          {
            placeholder: 'IP Address',
            labelText: null,
            hasInlineInfo: true,
            value: restriction ? restriction.ip_address : '',
            maxLength: 15,
            customErrors: {
              pattern: 'Your IP is invalid',
            },
            validators: [
              rxRequiredValidator,
              Validators.pattern(
                /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
              ),
              Validators.minLength(2),
              Validators.maxLength(15),
            ],
          },
          {
            component: RxTextareaComponent,
            placeholder: 'Physical Address',
            hasInlineInfo: true,
            value: restriction ? restriction.physical_address : '',
            maxLength: 120,
            validators: [Validators.maxLength(120)],
          },
        ],
      },
    };
  }

  public confirmArchive() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirmation required',
        tip: 'Are you sure you want to delete this IP address?',
        buttons: this.SubmitDismissButtons('Confirm', 'Cancel'),
      },
    };
  }

  public ipAddressInfo() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'What is IP address?',
        tip: ' An Internet Protocol address (IP address) is a numerical label assigned to each device connected to a computer network that uses the Internet for communication. An IP address can be used to identify the physical location where a connection to the internet is being made. RxPhoto allows you to limit access to our secure cloud by restricting access to pre-defined IP addresses. It should be noted that this feature only works with Fixed or “Static” IP addresses, not dynamic. If you are unsure if your IP is Static or Dynamic, please contact your network administrator. To find your IP address you may visit this site: <a href="http://whatismyipaddress.com/" target="_blank">http://whatismyipaddress.com/</a>',
        buttons: this.DismissButton('Close'),
      },
    };
  }
}
